import RpIcon from "@/components/RpIcon";
import { Stack } from "@mui/material";

export default function DetailHeader({ titleIcon, title, amount, currency, icon }) {
  return (
    <Stack direction={'row'} className={'container-wrap'} justifyContent={'space-between'}>
      <Stack>
        <Stack direction={'row'}>
          <RpIcon icon={titleIcon} size={16}/>
          <span className={'text-secondary'}>{title}</span>
        </Stack>
        <div>
          <span className={'text-primary-bold'}>{amount}</span> <span className={'text-primary'}>{currency}</span>
        </div>
      </Stack>
      <img src="/images/bill/bill.svg" alt="" width='72'/>
      {/*<RpIcon icon={icon} size={72}/>*/}
    </Stack>
  );
}
